import { ISeoMetaData } from '.'

export const mspSeoMetaData: ISeoMetaData[] = [
  {
    path: '/claims/msp',
    seo: {
      en: {
        title: 'Medicare Secondary Payer (MSP) Cases | Medicare',
        description: ''
      },
      es: {
        title: 'Casos de Medicare como Pagador Secundario (MSP) | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/claims/msp/disclaimer',
    seo: {
      en: {
        title: 'Medicare Secondary Payer (MSP) Disclaimer | Medicare',
        description: ''
      },
      es: {
        title: 'Descargo de responsabilidad de Medicare como Pagador Secundario (MSP) | Medicare',
        description: ''
      }
    }
  }
].map(seoMetaData => ({
  ...seoMetaData,
  component: 'Medicare Secondary Payer'
}))
